import { ApiCallGetMethod, ApiCallUploadMethodJson } from "../../constant/base";

export const Getagreement = (token) => {
  return ApiCallUploadMethodJson(`verify/agreement/${token}`, "POST");
};
export const GetSystemMessage = () => {
  return ApiCallGetMethod(`api/agreement/customer/message`);
};
